import { apiRequest, toAbsoluteApiUrl, withToken } from './http-client';

export const resolveCompanyLogoUrl = (settings = {}) => {
    const logoFileValue = settings?.logoFileId;

    if (logoFileValue && typeof logoFileValue === 'object') {
        const directUrl = String(logoFileValue.url || '').trim();
        if (directUrl) {
            return toAbsoluteApiUrl(directUrl);
        }

        const fileId = String(logoFileValue._id || '').trim();
        return fileId ? toAbsoluteApiUrl(`/api/file/public/${fileId}/content`) : '';
    }

    const fileId = String(logoFileValue || '').trim();
    if (fileId) {
        return toAbsoluteApiUrl(`/api/file/public/${fileId}/content`);
    }

    return '';
};

export const resolveCompanyLogoData = (company = {}) => {
    const logoFile = company?.settings?.logoFileId;

    if (!logoFile || typeof logoFile !== 'object') {
        return {
            logoFileId: '',
            logoUrl: resolveCompanyLogoUrl(company?.settings || {}),
            logoName: '',
            logoSizeBytes: 0,
        };
    }

    return {
        logoFileId: String(logoFile._id || ''),
        logoUrl: resolveCompanyLogoUrl(company?.settings || {}),
        logoName: String(logoFile.originalName || ''),
        logoSizeBytes: Number(logoFile.sizeBytes || 0),
    };
};

export const getCompanyData = async (token, { companyId } = {}) => {
    return apiRequest({
        method: 'get',
        url: `/company/${companyId}`,
        headers: withToken(token),
    }, 'No se pudieron obtener los datos de la empresa');
};

export const updateCompanyData = async (token, { companyId, payload } = {}) => {
    return apiRequest({
        method: 'patch',
        url: `/company/${companyId}`,
        headers: withToken(token),
        data: payload,
    }, 'No se pudo guardar la configuración de la empresa');
};
